module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAARNJREFUaEPtmrEJAkEURGcza7howcTUCmzAHmxBM61AM23BHmzACkwNFC7aGsyUwwXF5IaBFV3m0tu/n//uMXDLBhR8EuIIwCG3mDZoz6XahVIbd/smxDUQls8e902DdlWqX+lBtkCY50F2DdqFB+kh4C/CKJIQrRYD6n2N1WKIWS2G0scaq8VAs1oMJaslULJaAjSnFgPNajGUnFoCJaslQKsntfKRzQzAQADRVzIBwjgfPpwAHPsKhPc3APuQEC9AGAob/FDJ/VrVIN1p4P+rVdIPx69At574FYanS6wWjeq10Gox0KwWQ8n/IwIlqyVAc2ox0KwWQ8mpJVCyWgI0pxYDzWoxlJxaAqWarjl97eLZA73l+FNjvd92AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/添加学校.png
// module id = dkVs
// module chunks = 3